import axios from "axios";
import {
  isIOS,
  isAndroid,
  osName,
  osVersion
} from "react-device-detect";
import apiUrl from "./apiUrl";
import util from "../utilities/util";

const ostype = isIOS ? "mios" : isAndroid ? "mandroid" : "web";

let pageTitle = "";
let hideCancelInHeaderBar = false;
let hidetabBar = true;
let pageName = "";
  export function getPageName() {
    hideCancelInHeaderBar = false;
    hidetabBar = true;
    let path = "";
    const pathArray = window.location.hash ? window.location.hash.toLowerCase().split('/') : "";
    try {
      if (pathArray && pathArray.length > 0) {
        if (pathArray.length > 2 && pathArray[2] !== '') {
          if (pathArray[1].toLowerCase() === 'itplandingpage') {
            path = 'itplandingpage';
          } else if (pathArray[1].toLowerCase() === 'itpdestination') {
            path = 'itpdestination';
          } else if (pathArray[1].toLowerCase() === 'itptraveldates') {
            path = 'itptraveldates';
          } else if (pathArray[1].toLowerCase() === 'itpdeviceselection') {
            path = 'itpdeviceselection';
          } else if (pathArray[1].toLowerCase() === 'itpplanselection') {
            path = 'itpplanselection';
          } else if (pathArray[1].toLowerCase() === 'itpeffectivedate') {
            path = 'itpeffectivedate';
          } else if (pathArray[1].toLowerCase() === 'itpreview') {
            path = 'itpreview';
          } else if (pathArray[1].toLowerCase() === 'itpconfirmation') {
            path = 'itpconfirmation';
          } else if (pathArray[1].toLowerCase() === 'ildlandingpage') {
            path = 'ildlandingpage';
          } else if (pathArray[1].toLowerCase() === 'ilddestination') {
            path = 'ilddestination';
          } else if (pathArray[1].toLowerCase() === 'ilddeviceselection') {
            path = 'ilddeviceselection';
          } else if (pathArray[1].toLowerCase() === 'ildplans') {
            path = 'ildplans';
          } else if (pathArray[1].toLowerCase() === 'ildcountrylist') {
            path = 'ildcountrylist';
          } else if (pathArray[1].toLowerCase() === 'ildeffectivedate') {
            path = 'ildeffectivedate';
          } else if (pathArray[1].toLowerCase() === 'ildfeaturecompare') {
            path = 'ildfeaturecompare';
          } else if (pathArray[1].toLowerCase() === 'ildreviewpage') {
            path = 'ildreviewpage';
          } else if (pathArray[1].toLowerCase() === 'ildconfirmation') {
            path = 'ildconfirmation';
          } else if (pathArray[1].toLowerCase() === 'removeplanpage') {
            path = 'removeplanpage';
          } else if (pathArray[1].toLowerCase() === 'itpremoveplan') {
            path = 'itpremoveplan';
          } else if (pathArray[1].toLowerCase() === 'ildremoveplan') {
            path = 'ildremoveplan';
          } else if (pathArray[1].toLowerCase() === 'rpeffectivedate') {
            path = 'rpeffectivedate';
          } else if (pathArray[1].toLowerCase() === 'rpreview') {
            path = 'rpreview';
          } else if (pathArray[1].toLowerCase() === 'rpconfirmation') {
            path = 'rpconfirmation';
          } else if (pathArray[1].toLowerCase() === 'pendingorder') {
            path = 'pendingorder';
          } 
        }
        else {
          path = pathArray.length > 1 ? pathArray[1].toLowerCase() : "";
        }
      }
    } catch (ex) { }
  
    console.log("PATH1233", path);
  
  
    switch (path) {
      case "":
          pageName = "ITP_LANDING_PAGE";
          pageTitle = "ITP Landing Page";
          hideCancelInHeaderBar = true;
          hidetabBar = false;
          //util.loadChunkFile("1.mng");
          //util.loadChunkFile("1.epo");
          util.loadChunkFile("6.mm3");
          util.loadChunkFile("2.itpd");
          util.loadChunkFile("3.rp");
          util.loadChunkFile("4.ildL");
          
        break;
      case "itplandingpage":
        pageName = "ITP_LANDING_PAGE";
        pageTitle = "ITP Landing Page";
        util.loadChunkFile("6.mm3");
        break;
      case "itpdestination":
        pageName = "ITP_DESTINATION";
        pageTitle = "ITP Destination";
        break;
      case "itptraveldates":
        pageName = "ITP_TRAVELDATES";
        pageTitle = "ITP Traveldates";
        break;
      case "itpdeviceselection":
        pageName = "ITP_DEVICE_SELECTION";
        pageTitle = "ITP Device Selection";
        break;
      case "itpplanselection":
        pageName = "ITP_PLAN_SELECTION";
        pageTitle = "ITP Planselection";
        break;
      case "itpeffectivedate":
        pageName = "ITP_EFFECTIVEDATE";
        pageTitle = "ITP Effectivedate";
        break;
      case "itpreview":
        pageName = "ITP_REVIEW";
        pageTitle = "ITP Review";
        break;
      case "itpconfirmation":
        pageName = "ITP_CONFIRMATION";
        pageTitle = "ITP Confirmation";
        break;
      case "ildlandingpage":
        pageName = "ILD_LANDINGPAGE";
        pageTitle = "ILD Landingpage";
        break;
      case "ilddestination":
        pageName = "ILD_DESTINATION";
        pageTitle = "ILD Destination";
        break;
      case "ilddeviceselection":
        pageName = "ILD_DEVICE_SELECTION";
        pageTitle = "ILD Device Selection";
        break;
      case "ildplans":
        pageName = "ILD_PLANS";
        pageTitle = "ILD Plans";
        break;
      case "ildcountrylist":
        pageName = "ILD_COUNTRYLIST";
        pageTitle = "ILD Countrylist";
        break;
      case "ildeffectivedate":
        pageName = "ILD_EFFECTIVEDATE";
        pageTitle = "ILD Effectivedate";
        break;
      case "ildfeaturecompare":
        pageName = "ILD_FEATURE_COMPARE";
        pageTitle = "ILD Feature compare";
        hideCancelInHeaderBar = true;
        break;
      case "ildreviewpage":
        pageName = "ILD_REVIEW_PAGE";
        pageTitle = "ILD Review Page";
        break;
      case "ildconfirmation":
        pageName = "ILD_CONFIRMATION";
        pageTitle = "ILD Confirmation";
        break;
      case "removeplanpage":
        pageName = "REMOVE_PLAN_PAGE";
        pageTitle = "Remove Plan Page";
        hideCancelInHeaderBar = true;
        break;
      case "itpremoveplan":
        pageName = "REMOVE_PLAN_PAGE";
        pageTitle = "Remove Plan Page";
        hideCancelInHeaderBar = true;
        break;
      case "ildremoveplan":
        pageName = "REMOVE_PLAN_PAGE";
        pageTitle = "Remove Plan Page";
        hideCancelInHeaderBar = true;
        break;
      case "rpeffectivedate":
        pageName = "RP_EFFECTIVEDATE";
        pageTitle = "RP Effectivedate";
        break;
      case "rpreview":
        pageName = "RP_REVIEW";
        pageTitle = "RP Review";
        hideCancelInHeaderBar = true;
        break;
      case "rpconfirmation":
        pageName = "RP_CONFIRMATION";
        pageTitle = "RP Confirmation";
        break;
      case "pendingorder":
        pageName = "PENDING_ORDER";
        pageTitle = "Pending Order";
        break;      
      default:
        pageName = "DEFAULT";
        pageTitle = "ITP Landing Page";
        hideCancelInHeaderBar = false;
        hidetabBar = true;
    }
    console.log("page name hitted", pageName);
    return pageName;
  }
  export function logDisplayedError(errorMessage, errorCode) {
  try {
    if (!errorCode) {
      errorCode = "99";
    }

    (function eventTracker(n, errMsg, errCode) {
      var eventName = "errorEvent",
        params = {
          errorMsg: errMsg,
          errorCode: errCode
        };

      if (n++ < 30) {
        !window.vzwAnalytics
          ? setTimeout(function () {
            eventTracker(n);
          }, 750)
          : vzwAnalytics.events.track(eventName, params);
      }
    })(0, errorMessage, errorCode);

    //Set Omni tagging Notify
    omnitagging.setNotify(errorCode, errorMessage);

  } catch (ex) { }
  logJSError(errorCode, errorMessage, "NOTIFICATION");
}

  export function logJSError(errorStack, errorMsg, errorType, filename) {
    try {
      const currentPage = pageName; //getPageName();
      
      let jsError = {
        errorMessage: errorMsg,
        errorStack: errorStack,
        fileName: filename
      };
      // let dateTime = new Date().toLocaleString("en-US", { timeZone: "UTC" });
      let logPayload = {
  
        //dateTime: dateTime,
        logType: "CLICKSTREAM",
        //channelName: util.getChannelId(),
        osType: osName,
        osVersion: osVersion,
        serviceName: "clickstream",
        deviceType: ostype,
        //agentId: navigator.userAgent,
        pageName: currentPage,
        action: "JS-ERROR",
        flowName: errorType,
        apiRequest: '',
        interfaceName: currentPage,
        uiError: JSON.stringify(jsError),
        displayErrorMsg: errorMsg
      };
      console.log(`CLICK STREAM JS ERROR${  JSON.stringify(logPayload)}`);
  
      var axConfig = {
        headers: {
          OsType: ostype,
          "Content-Type": "application/json",
          channelId: util.getChannelId(),
          //"isexpresscpc": util.isExpressCPC() ? "true" : "false"
        },
        withCredentials: true
      };
      if (!(typeof enableUiLogging === "undefined" || enableUiLogging === null) && enableUiLogging) {
        // axios.post(apiUrl().uiLogging, JSON.stringify(logPayload), axConfig);
      }
    } catch (ex) { }
  }
  export function logNewrelicNoticeError(errorObject, logType, jsErrorMessage = '') {
    try {
  
      let dateTime = new Date().toLocaleString("en-US", { timeZone: "UTC" });
      /* const cookies = new Cookies();
      let sessionId = cookies.get("digital_ig_session"); */
      let sessionId = typeof (_dg_sessid) != "undefined" ? _dg_sessid : "intlmdotnsa";
      let logPayload = {
        dateTime: dateTime,
        logType: logType,
        channelId: util.getChannelId(),
        e2eRequestId: _dg_eReqId,
        e2erequestid:_dg_eReqId,
        url: window.location.href,
        sessionId: sessionId,
        errMsg: jsErrorMessage
      };
      console.log(`logNewrelicNoticeError${  JSON.stringify(logPayload)}`);
  
      if (typeof (newrelic) != "undefined" && typeof (newrelic.noticeError) != "undefined") {
        newrelic.noticeError(errorObject, logPayload);
      }
  
    } catch (ex) { console.log(`ex:${  ex}`); }
  }
  
  export function logNewrelicError(errorObject = {}, logType, jsErrorMessage = '') {
    try {
  
      let dateTime = new Date().toLocaleString("en-US", { timeZone: "UTC" });
      /* const cookies = new Cookies();
      let sessionId = cookies.get("digital_ig_session"); */
      let sessionId = typeof (_dg_sessid) != "undefined" ? _dg_sessid : "intlmdotnsa";
      let logPayload = {
        dateTime: dateTime,
        logType: logType,
        channelId: util.getChannelId(),
        e2eRequestId: _dg_eReqId,
        e2erequestid:_dg_eReqId,
        url: window.location.href,
        sessionId: sessionId,
        errMsg: jsErrorMessage
      };
      console.log(`logNewrelicNoticeError${  JSON.stringify(logPayload)}`);
  
      newrelic.noticeError(errorObject, logPayload);
  
  
    } catch (ex) { console.log(`ex:${  ex}`); }
  }

export function logNativeFunctionCall(nativePayload, executionTime) {
  try {
    // let dateTime = new Date().toLocaleString("en-US", { timeZone: "UTC" });
    let logPayload = {
      //dateTime: dateTime,
      logType: "CLICKSTREAM",
      //channelName: util.getChannelId(),
      osType: osName,
      osVersion: osVersion,
      deviceType: ostype,
      //agentId: navigator.userAgent,
      pageName: pageName,
      eventId: executionTime,
      interfaceName: pageName,
      serviceName: "clickstream",
      action: "NATIVE-CALL",
      flowName: pageName,
      apiRequest: nativePayload
    };
    var axConfig = {
      headers: {
        "Content-Type": "application/json",
        OsType: ostype,
        channelId: util.getChannelId(),
      },
      withCredentials: true
    };
    let url = apiUrl().uiLogging;
    if (!(typeof enableUiLogging === "undefined" || enableUiLogging === null) && enableUiLogging) {
      // axios.post(url, JSON.stringify(logPayload), axConfig);
    }
  } catch (ex) { }
}

export function logClickStream(
  interfaceName,
  activityName,
  clickstream,
  setTitle,
  cpcData
) {
  try {
    const currentPage = (clickstream === "PAGE-LOADED") ? getPageName() : pageName;
    const currentPageName = currentPage && currentPage.toLowerCase();
    let flowName = currentPage;
    let dataValue = "";
    let displayErrorMsg = "";
    if (clickstream === "ERROR_SHOWN") {

      if (activityName === "B-JS-ERR") {
        displayErrorMsg = "JS ERROR";
      } else {
        displayErrorMsg = "BannerMessage_AEM";
      }
    }
    if (clickstream === "PAGE-LOADED") {
      if (!(typeof vzwDL === "undefined" || vzwDL === null)) {
        flowName =
          vzwDL.page &&
            vzwDL.page.flowType &&
            vzwDL.page.flowType.split("|").length > 1
            ? vzwDL.page.flowType.split("|")[1]
            : currentPage;
        dataValue = getRequiredVzwDLValues(vzwDL, currentPageName);
      }
      //window.scrollTo(0, 0);
      //if(pageTitle !== "Manage Plan"){
      //nativeSetTitle(pageTitle, hidetabBar, hideCancelInHeaderBar);
      //}

     
    }

    // let dateTime = new Date().toLocaleString("en-US", { timeZone: "UTC" });
    let logPayload = {
      //dateTime: dateTime,
      logType: "CLICKSTREAM",
      //channelName: util.getChannelId(),
      osType: osName,
      osVersion: osVersion,
      deviceType: ostype,
      displayErrorMsg: displayErrorMsg,
      //agentId: navigator.userAgent,
      pageName: currentPage,
      eventId: activityName,
      interfaceName: interfaceName,
      action: clickstream,
      flowName: flowName,
      serviceName: "clickstream",
      apiResponse: cpcData ? JSON.stringify(cpcData) : JSON.stringify(dataValue)
    };
    console.log(`CLICK STREAM${JSON.stringify(logPayload)}`);

    var axConfig = {
      headers: {
        "Content-Type": "application/json",
        OsType: ostype,
        channelId: util.getChannelId(),
      },
      withCredentials: true
    };
    let url = apiUrl().uiLogging;
    if (clickstream && clickstream != "PAGE-LOADED") {
      if (!(typeof enableUiLogging === "undefined" || enableUiLogging === null) && enableUiLogging) {
        // axios.post(url, JSON.stringify(logPayload), axConfig);
      }
    }
  } catch (ex) { }
}

function getRequiredVzwDLValues(vzwDL, currentPageName) {
  let returnObject = {
    page: {},
    authentication: {}
  };
  try {
    if (!(typeof vzwDL === "undefined" || vzwDL === null)) {
      if (vzwDL.page) {

        let pageName = vzwDL.page.pageName;
      
        returnObject["page"] = {
          area: vzwDL.page.area,
          authStatus: vzwDL.page.authStatus,
          channel: vzwDL.page.channel,
          condition: vzwDL.page.condition,
          flowName: vzwDL.page.flowName,
          flowType: vzwDL.page.flowType,
          globalId: vzwDL.page.globalId,
          hier1: vzwDL.page.hier1,
          language: vzwDL.page.language,
          lineOfBusiness: vzwDL.page.lineOfBusiness,
          platform: vzwDL.page.platform,
          state: vzwDL.page.state,
          typeIndicator: vzwDL.page.typeIndicator,
          zipCode: vzwDL.page.zipCode,
          mlsExp: vzwDL.page.mlsExp,
          pageName: vzwDL.page.pageName,
          pageType: vzwDL.page.pageType,
          section2: vzwDL.page.section2,
          section3: vzwDL.page.section3
        };
      }
      if (vzwDL.authentication) {
        returnObject["authentication"] = vzwDL.authentication;
      }
    }
  } catch (ex) { }
  return returnObject;
}

